/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

 
import parsePhoneNumberFromString from "libphonenumber-js";

const PHONE_NUMBER_PATTERN = /^\+[1-9]\d{8,14}$/;

export const normalizePhoneNumber = (number) => {
  const phoneNumber = `${number ?? ""}`.trim();

  if (!phoneNumber) {
    return "";
  }

  return phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
};

/**
 * @description Validates a phone number either with the general libphonenumber check or the strict
 * format when requested.
 * @param {string} number The phone number entered by the user.
 * @param {{ strictFormat?: boolean }} [options] Validation options.
 * @param {boolean} [options.strictFormat=false] When true, requires the backend format `+` followed
 * by 9 to 15 digits.
 * @returns {boolean} True when the phone number is valid for the selected mode, otherwise false.
 */
export function validatePhoneNumber(number, { strictFormat = false } = {}) {
  const phoneNumber = `${number ?? ""}`.trim();

  if (!phoneNumber) {
    return false;
  }

  if (strictFormat) {
    return PHONE_NUMBER_PATTERN.test(phoneNumber);
  }

  const phone = parsePhoneNumberFromString(phoneNumber);

  if (!phone) return false;

  if (!phone?.nationalNumber || phone?.nationalNumber?.trim()?.length === 0) {
    return false;
  }

  return true;
}
